import { API, graphqlOperation } from "aws-amplify"
import { getFccArticle, queryFccArticleReportsByByFccReport, listArticles, listFccOutlets, 
  listArticleReports, queryArticlesByListArticlesSortByCreatedAt } from "../graphql/queries"

import { sortOrderName } from "./modelUtil"


/**
 * Get ArticleReport (join table) associations by report Id.
 * Then get each article associated with the report.
 * @param {*} reportId
 * @returns List of article/report associations.
 */
export const fetchArticlesByReportId = async (reportId) => {
  try {

    let articleReports = []

    // Get article/report associations
    const articleReportResponse = await API.graphql(
      graphqlOperation(queryFccArticleReportsByByFccReport, { fccReportId: reportId }
    ))

    articleReports = articleReportResponse.data.queryFccArticleReportsByByFccReport.items
    articleReports = articleReports.filter((record) => record && !record._deleted)

    // Get each article associated with the report
    const fetchAllArticles = articleReports.map((articleReport) =>
      API.graphql(graphqlOperation(getFccArticle, { id: articleReport.fccArticleId }))
    )

    const articleResponses = await Promise.all(fetchAllArticles)
    let articles = articleResponses.map((res) => res.data.getFccArticle)

    // remove deleted articles
    articles = articles.filter((record) => record && !record._deleted)

    return articles

  } catch (error) {
    throw error
  }
}


/**
 * Get all outlets.
 * @returns List of outlets.
 */
export const fetchOutlets = async () => {
  try {
    const res = await API.graphql(
      graphqlOperation(listFccOutlets, { limit: 200000 })
    )
    let items = res.data.listFccOutlets.items;
    items = items.filter((record) => !record._deleted);
    items = sortOrderName(items, "name");
    return items;
  } catch (err) {
    throw ("Error fetching outlets:", err);
  }
};


// /**
//  * Search articles by title or content.
//  * @param {*} searchTerm Search term.
//  * @returns List of articles.
//  */
// export const fetchSearchResults = async (searchTerm, limit) => {
//   try {
//     // const res = await API.graphql(
//     //   graphqlOperation(listArticles, {
//     //     filter: {
//     //       or: [
//     //         { title: { contains: searchTerm } },
//     //         { content : { contains: searchTerm } },
//     //       ],
//     //     },
//     //   })
//     // )
//     // let items = res.data.listArticles.items

//     const res = await API.graphql(
//       graphqlOperation(queryArticlesByListArticlesSortByCreatedAt, {
//         sortCreatedAt: "T",
//         sortDirection: "DESC",
//         first: limit,
//         filter: {
//           or: [
//             { title: { contains: searchTerm } },
//             { content : { contains: searchTerm } },
//           ],
//         },
//       })
//     )
//     let items = res.data.queryArticlesByListArticlesSortByCreatedAt.items


//     items = items.filter((record) => !record._deleted)
//     items = sortOrderName(items, "createdAt")
//     return items;
//   } catch (err) {
//     throw ("Error searching articles:", err)
//   }
// }